/**
 * Qwen-klaar (opdracht Frank 3 november 2026): het model voor code op een andere machine, met een instelling.
 *
 * De keuze blijft EEN waarde in `code_model`, zoals sinds LC1 en GL222-5: `soort@adres|model`. Voorbeelden:
 *   ollama@http://192.168.1.20:11434|qwen2.5-coder:14b
 *   lmstudio@http://192.168.1.20:1234|qwen2.5-coder-14b-instruct
 * Een kale naam blijft een model op de Ollama van deze Mac, en `aanbieder|model` blijft een cloudmodel. De server
 * controleert het adres (alleen een machine in het eigen netwerk) en of het model daar code kan schrijven. PUUR.
 */
export const SOORTEN = { ollama: "Ollama", lmstudio: "LM Studio" };
export const STANDAARD_POORT = { ollama: 11434, lmstudio: 1234 };

/** De ene waarde voor `code_model` uit soort, adres en model; leeg als er iets ontbreekt. PUUR. */
export function adresKeuze(soort, adres, model) {
  const a = (adres || "").trim().replace(/\/+$/, "");
  const m = (model || "").trim();
  if (!SOORTEN[soort] || !a || !m) return "";
  return `${soort}@${a}|${m}`;
}

/** {soort, adres, model} uit een keuze met adres, of null voor elke andere keuze. PUUR. */
export function leesAdresKeuze(waarde) {
  const v = (waarde || "").trim();
  const at = v.indexOf("@");
  const streep = v.lastIndexOf("|");
  if (at <= 0 || streep < at) return null;
  const soort = v.slice(0, at);
  if (!SOORTEN[soort]) return null;
  const adres = v.slice(at + 1, streep);
  const model = v.slice(streep + 1);
  return adres && model ? { soort, adres, model } : null;
}

const ZELF = (tekst, w) => tekst.replace(/\{(\w+)\}/g, (_, k) => w[k]);

/** Hoe een keuze met adres in de lijst heet: "qwen2.5-coder:14b op 192.168.1.20 (Ollama)". `t` vertaalt. PUUR. */
export function adresLabel(waarde, t = ZELF) {
  const k = leesAdresKeuze(waarde);
  if (!k) return null;
  let host = k.adres;
  try {
    host = new URL(k.adres).hostname;
  } catch {
    // geen geldig adres: dan de tekst zoals hij is; de server weigert hem bij het opslaan
  }
  return t("{model} op {host} ({soort})", { model: k.model, host, soort: SOORTEN[k.soort] });
}
